<div class="action-bar-user" [matMenuTriggerFor]="signOutMenu">
  <blaze-avatar [user]="user$ | async" [isProjectUrl]="isProjectUrl()" />
  @if (!isProjectUrl()) {
    <div class="expand-menu-icon ml-8">
      <mat-icon svgIcon="icon_chevron_down_16" class="icon-16" />
    </div>
  }
</div>

<mat-menu #signOutMenu="matMenu" class="bd-menu action-bar-user-options">
  <button mat-menu-item (click)="onOpenUserProfile()">My Profile</button>
  <button mat-menu-item (click)="onSignOut()">Sign Out</button>
</mat-menu>
